export const LIST_CUSTOMER_LOAN = 'LIST_CUSTOMER_LOAN';
export const STORE_CUSTOMER_LOAN = 'STORE_CUSTOMER_LOAN';
export const SAVE_CUSTOMER_LOAN = 'SAVE_CUSTOMER_LOAN';

export const STORE_BORROWERS = 'STORE_BORROWERS';
export const STORE_BORROWER = 'STORE_BORROWER';
export const REMOVE_BORROWER = 'REMOVE_BORROWER';

export const CREATE_BORROWER = 'CREATE_BORROWER';
export const EDIT_BORROWER = 'EDIT_BORROWER';
export const ADD_TRANSACTION = 'ADD_TRANSACTION';
export const EDIT_TRANSACTION = 'EDIT_TRANSACTION';
export const DELETE_TRANSACTION = 'DELETE_TRANSACTION';
export const DELETE_BORROWER = 'DELETE_BORROWER';
